import React from "react";
import Typewriter from "typewriter-effect";

function Type() {
  return (
    <Typewriter
      options={{
        strings: [
          "AI Engineer",
          "Deep Learning Specialist",
          "Computer Vision Engineer",
          "Natural Language Processing Engineer",
        ],
        autoStart: true,
        loop: true,
        deleteSpeed: 30,
		delay: 1,
      }}
    />
  );
}

export default Type;
